import { Card, Col, Row, Form, Input, Button, Layout, Spin, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { SecondaryButton } from '../../Commons';
import logo from '../Login/images/logo_v_png.png';
import loginBG from '../Login/images/bg.jpg';
import './style.scss';
import { api } from '../../Http';
import { 
	AiOutlineCheckCircle as CheckCircleOutlined, 
	AiTwotoneEyeInvisible as EyeTwoTone, 
	AiOutlineEyeInvisible as EyeInvisibleOutlined,
	AiOutlineQuestionCircle as QuestionCircleOutlined
 } from 'react-icons/ai';
import styled from 'styled-components';
import { Content } from 'antd/lib/layout/layout';
import ResetExpireError from './ResetExpireError';
import { passwordPolicy, validatePassword } from '../../utils/validationUtils';

const styles = {
	error: {
		textAlign: 'center',
		margin: '1rem',
		fontSize: '16px',
		fontWeight: 'bold',
		color: '#cf4500',
	},
	success: {
		textAlign: 'center',
		margin: '1rem',
		fontSize: '22px',
		fontWeight: 'bold',
		color: '#22BB33',
	},
	login:{
		textAlign: 'center',
		margin: '1rem',
		fontSize: '22px',
		color: 'blue',
	}
};

const ChangePassPage = () => {
	const { Background } = StyledComponents;
	const [form] = Form.useForm();
	const [validate, setValidate] = useState(false);
	const [resp, setResponse] = useState(undefined);
	const [loading, setLoading] = useState(false);
	const [token, setToken] = useState(null);

	useEffect(() => {
		const tokenParam = new URLSearchParams(window.location.search).get('token');
		setToken(tokenParam);
	
		if (!tokenParam) {
		  setResponse({ msg: 'Invalid or missing token.', success: false });
		  return;
		}
	
		const validateToken = async () => {
		  try {
			setLoading(true);
			const response = await api.post('/account/token-validate', { token:tokenParam }, { withCredentials: false });
			if (response.data.code === 0) {
			  setValidate(true);
			} else {
			  setResponse({ msg: response.data.message, success: false });
			}
		  } catch (e) {
			const errorMsg = e.response?.data?.message || 'Error validating token.';
			setResponse({ msg: errorMsg, success: false });
		  } finally {
			setLoading(false);
		  }
		};
	
		validateToken();
	  }, []);

	if(!validate){
		return(
			<ResetExpireError resp={resp} />
		)
	}

	const onSubmit = async (values) => {
		
		try {
			setLoading(true);
			const response = await api.post('/account/change-password', values, {
				withCredentials: false,
				params: { token },
			});
			if (response.data.code === 0) {
				setResponse({ msg: response.data.message, success: true });
			} else {
				setResponse({ msg: response.data.message, success: false });
			}
		} catch (e) {
			const errorMsg = e.response?.data?.message || 'Error changing password.';
			setResponse({ msg: errorMsg, success: false });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Layout>
			<Content>
				<Background justify='center' align='middle'>
					<Col xs={22} sm={16} md={12} lg={10} xl={8} xxl={7}>
						<Card title='Change Password' className='change-pass-card'>
							<a href="https://nettverk.io/" target="_blank" rel='noreferrer'>
								<img className='logo' src={logo} alt='logo'/>
							</a>
							{loading ? (
								<div style={{display:"flex", justifyContent:"center", alignItems:'center'}}>
									<Spin size="large" />
								</div>
							) : !resp?.success ? (
								<React.Fragment>
									{resp && resp.msg && (
										<div style={styles.error}>
											{resp?.msg.split("\n").map((line, index) => (
												<ol style={{listStyleType:"none", padding:"0",lineHeight:"5px"}}>
													<li key={index}>{line}</li>
												</ol>
											
											))}
											{/* <div style={styles.error}>
												{resp.msg}</div> */}
										</div>
									)}
									<Form form={form} layout='vertical' onFinish={onSubmit} style={{ textAlign: 'center', marginTop: '2rem' }}>
										<Form.Item
											name='password'
											rules={[{ validator: validatePassword(form) }]}
										>
											   
											{/* <Input.Password className='txt-field' placeholder='New Password..'></Input.Password> */}
											<div style={{ display: 'flex', alignItems: 'center', position: 'relative', width:'70%', margin:'auto' }}>
												{/* Password Input */}
												<Input.Password
													className="txt-field"
													placeholder="New Password..."
													style={{ flex: 1, paddingRight: '35px', margin:'0px' }} // Ensure space for the icon
													iconRender={(visible) =>
														visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
													}
												/>

												{/* Tooltip for Password Policy - Fixed Position */}
												<Tooltip color='grey' placement="topLeft" title={passwordPolicy} trigger="click">
													<span
														style={{
															position: 'absolute',
															right: '10px',
															fontSize: '12px',
															cursor: 'pointer',
															color: 'grey',
															zIndex: 100, // Ensure it stays visible
														}}
														onClick={(e) => e.stopPropagation()} // Prevent focus loss
													>
														<QuestionCircleOutlined />
													</span>
												</Tooltip>
											</div>
										</Form.Item>
										
										<Form.Item
											name='confirmPassword'
											dependencies={['password']}
											hasFeedback
											rules={[
												{
													required: true,
													message: 'Please confirm your password!',
												},
												({ getFieldValue }) => ({
													validator(_, value) {
														if (!value || getFieldValue('password') === value) {
															return Promise.resolve();
														}
														return Promise.reject(new Error('The two passwords that you entered do not match!'));
													},
												}),
											]}
											>
											<Input.Password
											 className='txt-field' 
											 placeholder='Confirm Password..'
											 suffix={
												<Tooltip title={passwordPolicy} trigger="click">
													<QuestionCircleOutlined style={{ fontSize: '18px', cursor: 'pointer' }} />
												</Tooltip>
											}
									
											 ></Input.Password>
										</Form.Item>
										<Form.Item>
											<SecondaryButton style={{borderRadius:"5px", width:"100%"}} className='nv-btn' htmlType='submit' type='primary' size='large' block>Submit</SecondaryButton>
										</Form.Item>
									</Form>
								</React.Fragment>
							) : (
								<div>
									<div style={styles.success}>
										<CheckCircleOutlined /> {resp.msg}{' '}
									</div>
									<div style={styles.login}>
										<Link to={`/login`}>
											Go to Login
										</Link>
									</div>
								</div>
							)}
						</Card>
					</Col>
				</Background>
			</Content>
		</Layout>
	);
};
export default ChangePassPage;
const StyledComponents = {
	Background: styled(Row)`
		height: 100vh;
		background-image: url(${loginBG});
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	`,
	SubmitButton: styled(Button)``,
};
